import moment from 'moment'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { Col } from 'react-styled-flexboxgrid'

import Datepicker from '@components/Datepicker'
import RightSidebarFloat from '../../../components/RightSidebarFloat'
import { SidebarProp } from './interface'
import { StyledRow } from './style'

const Sidebar: React.FC<SidebarProp> = ({ currentDate = moment(), setCurrentDate, lessonDates }) => (
  <RightSidebarFloat
    hideHeaderOnLg
    header={<FormattedMessage id="My schedule" />}
    body={
      <StyledRow>
        <Col xs={12} lg={false}>
          <Datepicker
            borderless
            inline
            selected={currentDate.toDate()}
            onChange={setCurrentDate}
            dayClassName={(date: string) => {
              const lessonDay = lessonDates.find(lessonDate =>
                moment(lessonDate.date, 'YYYY-MM-DD').isSame(moment(date, moment.defaultFormat))
              )

              return lessonDay && `react-datepicker__day--highlighted-count-${lessonDay.numberOfLessons}`
            }}
            className="popped-over"
          />
        </Col>
      </StyledRow>
    }
  />
)

export default Sidebar
